import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as componentTypes from "../constants/componentTypes";
import * as keyCodes from "../constants/keyCodes";
import * as settings from "../constants/settings";
import * as handlers from "../constants/handlers";
import * as config from "../constants/config";
import * as rcc from "../constants/rcc";
import * as modules from "../constants/modules";
import * as resources from "../constants/resources";
import * as mainTabActions from "../actions/mainTabActions";
import * as navigationActions from "../actions/navigationActions";
import * as rccActions from "../actions/rccActions";
import * as settingsActions from "../actions/settingsActions";
import * as windowService from "./windowService";
import * as messageHelper from "../helpers/messageHelper";
import * as getterHelper from "../helpers/getterHelper";

const zoomIn = (zoom) => {
    return settingsActions.setZoom(zoom + config.ZOOM_STEP);
};

const zoomOut = (zoom) => {
    return settingsActions.setZoom(zoom - config.ZOOM_STEP);
};

const focusOnBarcodeScannerInput = () => {
    if (isFocused()) {
        document.activeElement.className = document.activeElement.className + " original-focused-element";
    }

    windowService.logInfo("Barcode        : Focus");
    window.jQuery("#barcode-scanner-input").focus();

    return {
        type: actionTypes.BARCODE_RESET
    };
};

const checkDispensing = (store) => {
    if (
        !store.rcc.connected ||
        !store.rcc.machine.isConnected ||
        store.rcc.dispensingFormula ||
        store.rcc.machine.errors.length > 0 ||
        store.rcc.machine.isBusy ||
        store.rcc.machine.isDispensing ||
        store.navigation.activeMenu
    ) {
        return {
            type: actionTypes.UNKNOWN_ACTION
        };
    }

    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].active &&
        store.formula[store.navigation.activeTab].formula !== null
    ) {
        return mainTabActions.startFormulaDispensing(store.navigation.activeTab);
    }

    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].formula !== null &&
        store.navigation.activeTab === componentTypes.QUICK_TINT_TAB_ID
    ) {
        return mainTabActions.startQuickDispensing(store.navigation.activeTab);
    }

    if (
        store.navigation.activeTabType === componentTypes.TO_DISPENSE_TAB &&
        store.toDispense.activeOrder !== null &&
        store.toDispense.activeOrder.databaseAvailability === componentTypes.ORDER_DATABASE_AVAILABLE_OK
    ) {
        return {
            type: actionTypes.USER_AUTHENTICATION,
            payload: {
                tabId: store.navigation.activeTab,
                next: rccActions.startOrderDispensing(store.navigation.activeTab, store.toDispense.activeOrder.id)
            }
        };
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const checkDispensingLight = (store) => {
    if (
        !store.rcc.connected ||
        !store.rcc.machine.isConnected ||
        store.rcc.dispensingFormula !== null ||
        store.rcc.machine.errors.length > 0 ||
        store.rcc.machine.isBusy ||
        store.rcc.machine.isDispensing
    ) {
        return {
            type: actionTypes.UNKNOWN_ACTION
        };
    }

    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.navigation.activeTabScene === componentTypes.SUMMARY_SCENE &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].active
    ) {
        return mainTabActions.startFormulaDispensing(store.navigation.activeTab);
    }

    if (
        store.navigation.activeTabType === componentTypes.TO_DISPENSE_TAB &&
        store.navigation.activeTabScene === componentTypes.DETAIL_SCENE &&
        store.toDispense.activeOrder !== null &&
        store.toDispense.activeOrder.databaseAvailability === componentTypes.ORDER_DATABASE_AVAILABLE_OK
    ) {
        return {
            type: actionTypes.USER_AUTHENTICATION,
            payload: {
                tabId: store.navigation.activeTab,
                next: rccActions.startOrderDispensing(store.navigation.activeTab, store.toDispense.activeOrder.id)
            }
        };
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const checkPrint = (store) => {
    if (
        store.login.loggedUser.canNotRead(resources.FUNCTION_PRINT) ||
        !store.settings.printOnRequest ||
        !store.rcc.connected ||
        store.navigation.activeMenu
    ) {
        return {
            type: actionTypes.UNKNOWN_ACTION
        };
    }

    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].active
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_MODAL,
            payload: {
                tabId: store.navigation.activeTab,
                type: componentTypes.PRINT_MODAL,
                params: {
                    formula: store.formula[store.navigation.activeTab].formula,
                    printData: store.formula[store.navigation.activeTab].printData,
                    moreInfoText: store.formula[store.navigation.activeTab].moreInfoText,
                    dispenseNote: store.formula[store.navigation.activeTab].dispenseNote
                }
            }
        };
    }

    if (store.navigation.activeTabType === componentTypes.TO_DISPENSE_TAB && store.toDispense.activeOrder !== null) {
        return {
            type: actionTypes.NAVIGATION_OPEN_MODAL,
            payload: {
                tabId: store.navigation.activeTab,
                type: componentTypes.PRINT_PREVIEW_ORDER_MODAL
            }
        };
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const checkPrintLight = (store) => {
    if (
        store.login.loggedUser.canNotRead(resources.FUNCTION_PRINT) ||
        !store.settings.printOnRequest ||
        !store.rcc.connected
    ) {
        return {
            type: actionTypes.UNKNOWN_ACTION
        };
    }

    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.navigation.activeTabScene === componentTypes.SUMMARY_SCENE &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].active
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_MODAL,
            payload: {
                tabId: store.navigation.activeTab,
                type: componentTypes.PRINT_MODAL,
                params: {
                    formula: store.formula[store.navigation.activeTab].formula,
                    printData: store.formula[store.navigation.activeTab].printData,
                    moreInfoText: store.formula[store.navigation.activeTab].moreInfoText,
                    dispenseNote: store.formula[store.navigation.activeTab].dispenseNote
                }
            }
        };
    }

    if (
        store.navigation.activeTabType === componentTypes.TO_DISPENSE_TAB &&
        store.navigation.activeTabScene === componentTypes.DETAIL_SCENE &&
        store.toDispense.activeOrder !== null
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_MODAL,
            payload: {
                tabId: store.navigation.activeTab,
                type: componentTypes.PRINT_PREVIEW_ORDER_MODAL
            }
        };
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const checkOrder = (store) => {
    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].active &&
        !store.navigation.activeMenu
    ) {
        return mainTabActions.createOrder(store.navigation.activeTab);
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const closeActiveTab = (store) => {
    let dispensingTabId = null;

    if (store.rcc.dispensingFormula !== null) {
        for (let tab of store.navigation.tabList) {
            if (store.formula[tab.id]?.dispensing === true) {
                dispensingTabId = tab.id;
                break;
            }
        }
    }

    return navigationActions.closeActiveTab(store.navigation.activeTab, store.navigation.tabList, dispensingTabId);
};

const checkOrderLight = (store) => {
    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.navigation.activeTabScene === componentTypes.SUMMARY_SCENE &&
        store.formula[store.navigation.activeTab] !== undefined &&
        store.formula[store.navigation.activeTab].active
    ) {
        return mainTabActions.createOrder(store.navigation.activeTab);
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const selectBiggerPackageSize = (store) => {
    let previousPackage = null;

    for (let pack of store.formula[store.navigation.activeTab].packageList) {
        if (previousPackage !== null) {
            return {
                type: actionTypes.MAIN_TAB_SET_PACKAGE,
                payload: {
                    tabId: store.navigation.activeTab,
                    selectedPackage: pack,
                    previousPackage: previousPackage
                }
            };
        }

        if (pack.id === store.formula[store.navigation.activeTab].package.id) {
            previousPackage = pack;
        }
    }
    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const selectSmallerPackageSize = (store) => {
    let nextPackage = null;

    for (let previousPackage of store.formula[store.navigation.activeTab].packageList) {
        if (previousPackage.id === store.formula[store.navigation.activeTab].package.id) {
            if (nextPackage === null) {
                return {
                    type: actionTypes.UNKNOWN_ACTION
                };
            }

            return {
                type: actionTypes.MAIN_TAB_SET_PACKAGE,
                payload: {
                    tabId: store.navigation.activeTab,
                    selectedPackage: nextPackage,
                    previousPackage: previousPackage
                }
            };
        }

        nextPackage = previousPackage;
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const selectDifferentPackageNumber = (store, keyCode) => {
    let numberOfPackages = store.formula[store.navigation.activeTab].numCanTotal;
    if (keyCode === keyCodes.UP_ARROW) {
        if (numberOfPackages < config.MAX_NUMBER_OF_PACKAGES) {
            return {
                type: actionTypes.SET_NUMBER_OF_PACKAGES,
                payload: {
                    tabId: store.navigation.activeTab,
                    numberOfPackages: numberOfPackages + 1
                }
            };
        }
    }

    if (keyCode === keyCodes.DOWN_ARROW) {
        if (numberOfPackages > 1) {
            return {
                type: actionTypes.SET_NUMBER_OF_PACKAGES,
                payload: {
                    tabId: store.navigation.activeTab,
                    numberOfPackages: numberOfPackages - 1
                }
            };
        }
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const onScannerEnterPress = (store) => {
    windowService.logInfo("Barcode        : Enter");
    window.jQuery("#barcode-scanner-input").blur();

    if (window.jQuery(".original-focused-element").length) {
        window.jQuery(".original-focused-element").focus();
        window.jQuery(".original-focused-element").removeClass("original-focused-element");
    }

    if (
        store.navigation.activeMenu &&
        store.navigation.activeSubmenuItem === componentTypes.SUBMENU_CANISTER_SETTINGS
    ) {
        windowService.logInfo(
            "Barcode        : Reading barcode to assign barcode to canister - " + store.barcode.barcode
        );

        return null;
    }

    if (store.navigation.modalList.length > 0) {
        let modalType = store.navigation.modalList[store.navigation.modalList.length - 1].type;

        if (modalType === componentTypes.BARCODE_TEST_MODAL) {
            windowService.logInfo(
                "Barcode        : Searching item by barcode for test purpose - " + store.barcode.barcode
            );

            return {
                type: actionTypes.SERVER_REQUEST,
                payload: {
                    type: methods.METHOD_GET_ITEM_BY_BARCODE,
                    params: {
                        barcode: store.barcode.barcode
                    }
                },
                method: handlers.GET_ITEM_BY_BARCODE_TEST,
                tabId: 0
            };
        }

        if (modalType === componentTypes.CANISTER_BARCODE_MODAL) {
            windowService.logInfo(
                "Barcode        : Reading barcode to assign barcode to canister - " + store.barcode.barcode
            );

            return null;
        }

        if (
            modalType === componentTypes.REFILL_CONFIRMATION_MODAL ||
            modalType === componentTypes.SET_CANISTER_UFI_CODE_MODAL
        ) {
            windowService.logInfo("Barcode        : Reading UFI code from barcode - " + store.barcode.barcode);

            return {
                type: actionTypes.SERVER_REQUEST,
                payload: {
                    type: methods.METHOD_GET_ITEM_BY_BARCODE,
                    params: {
                        barcode: store.barcode.barcode
                    }
                },
                method: handlers.GET_ITEM_BY_BARCODE_TEST,
                tabId: 0
            };
        }

        if (modalType === componentTypes.ADD_COLORANT_PACKAGES_TO_STOCK_MODAL) {
            windowService.logInfo("Barcode        : Reading colorant package from barcode - " + store.barcode.barcode);

            return {
                type: actionTypes.SERVER_REQUEST,
                payload: {
                    type: methods.METHOD_GET_ITEM_BY_BARCODE,
                    params: {
                        barcode: store.barcode.barcode
                    }
                },
                method: handlers.GET_ITEM_BY_BARCODE_TEST,
                tabId: 0
            };
        }
    }

    if (store.rcc.machine.dialog !== null) {
        if (store.rcc.machine.dialog.message === rcc.RCC_MESSAGE_VALIDATE_BASE_CAN) {
            windowService.logInfo("Barcode        : Validation of base in product barcode - " + store.barcode.barcode);

            if (
                store.login.loggedUser.canEdit(resources.FUNCTION_VALIDATE_ORDER_PACKAGE) &&
                store.toDispense.dispensedOrder !== null
            ) {
                return {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ITEM_BY_BARCODE,
                        params: {
                            barcode: store.barcode.barcode
                        }
                    },
                    method: handlers.GET_ITEM_BY_BARCODE,
                    tabId: 0
                };
            }

            if (store.rcc.machine.dialog.params.length > 0) {
                if (
                    store.barcode.barcode === config.UNIVERSAL_BASE_SCAN_CODE ||
                    store.rcc.machine.dialog.meta === null ||
                    !Array.isArray(store.rcc.machine.dialog.meta.details)
                ) {
                    return {
                        type: actionTypes.MACHINE_DIALOG_CONTINUE
                    };
                }

                return {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE,
                        params: {
                            productName:
                                store.rcc.machine.dialog.meta.details[0] === undefined
                                    ? null
                                    : store.rcc.machine.dialog.meta.details[0],
                            baseName:
                                store.rcc.machine.dialog.meta.details[1] === undefined
                                    ? null
                                    : store.rcc.machine.dialog.meta.details[1],
                            packageName:
                                store.rcc.machine.dialog.meta.details[2] === undefined
                                    ? null
                                    : store.rcc.machine.dialog.meta.details[2],
                            barcode: store.barcode.barcode,
                            databaseName:
                                store.toDispense.dispensedOrder !== null
                                    ? store.toDispense.dispensedOrder.databaseName
                                    : null
                        }
                    },
                    method: handlers.VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE,
                    tabId: 0
                };
            }
        }

        if (store.rcc.machine.dialog.type === componentTypes.MACHINE_DIALOG_REFILL) {
            windowService.logInfo("Barcode        : Barcode refill");

            if (store.rcc.machine.refillValidation === null || !store.rcc.machine.refillValidation.isCanisterValid()) {
                windowService.logInfo("Barcode        : Barcode refill - canister - " + store.barcode.barcode);

                return {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_CANISTER_BY_BARCODE,
                        params: {
                            barcode: store.barcode.barcode
                        }
                    },
                    method: handlers.MACHINE_GET_CANISTER_BY_BARCODE,
                    tabId: 0,
                    safe: true
                };
            }

            if (
                store.rcc.machine.refillValidation !== null &&
                store.rcc.machine.refillValidation.isCanisterValid() &&
                !store.rcc.machine.refillValidation.isValid()
            ) {
                windowService.logInfo("Barcode        : Barcode refill - colorant package - " + store.barcode.barcode);

                return {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ITEM_BY_BARCODE,
                        params: {
                            barcode: store.barcode.barcode
                        }
                    },
                    method: handlers.INTERGAMMA_GET_COLORANT_PACKAGE_BY_BARCODE,
                    tabId: 0
                };
            }
        }

        if (
            store.rcc.machine.dialog.message === rcc.RCC_MESSAGE_READ_BASE_UFI_CODE ||
            store.rcc.machine.dialog.message === rcc.RCC_MESSAGE_VALIDATE_BASE_UFI_CODE
        ) {
            windowService.logInfo("Barcode        : Reading UFI code from barcode - " + store.barcode.barcode);

            return {
                type: actionTypes.SERVER_REQUEST,
                payload: {
                    type: methods.METHOD_GET_ITEM_BY_BARCODE,
                    params: {
                        barcode: store.barcode.barcode
                    }
                },
                method: handlers.GET_ITEM_BY_BARCODE_TEST,
                tabId: 0
            };
        }
    }

    if (
        store.formula[store.navigation.activeTab] === undefined &&
        store.license.licensed &&
        store.server.compatible &&
        store.server.compatibleDatabase &&
        store.server.availableDatabase
    ) {
        windowService.logInfo("Barcode        : Searching item by barcode - " + store.barcode.barcode);

        return {
            type: actionTypes.SERVER_REQUEST,
            payload: {
                type: methods.METHOD_GET_ITEM_BY_BARCODE,
                params: {
                    barcode: store.barcode.barcode
                }
            },
            method: handlers.GET_ITEM_BY_BARCODE,
            tabId: store.navigation.activeTab
        };
    }

    if (
        store.formula[store.navigation.activeTab] !== undefined &&
        getterHelper.isFormulaTab(store.navigation.activeTabType)
    ) {
        return {
            type: actionTypes.SERVER_REQUEST,
            payload: {
                type: methods.METHOD_GET_ITEM_BY_BARCODE,
                params: {
                    barcode: store.barcode.barcode
                }
            },
            method: handlers.GET_FORMULA_ITEMS_BY_BARCODE,
            tabId: store.navigation.activeTab
        };
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const processRedlikeShortcut = (event, store) => {
    let manualShortcuts = store.settings.keyboardShortcuts;

    if (
        manualShortcuts[settings.SHORTCUT_CHANGELOG] !== undefined &&
        manualShortcuts[settings.SHORTCUT_CHANGELOG].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_CHANGELOG)
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_JUST_ONE_MODAL,
            payload: {
                tabId: componentTypes.MODAL_NO_TAB,
                type: componentTypes.CHANGELOG_MODAL,
                style: componentTypes.MODAL_DEFAULT_STYLE
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_NEW_TAB] !== undefined &&
        manualShortcuts[settings.SHORTCUT_NEW_TAB].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_FORMULA_TAB)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return {
            type: actionTypes.ADD_NEW_TAB,
            payload: {
                type: store.settings.additionalTabType,
                scene: null
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_CLOSE_TAB] !== undefined &&
        manualShortcuts[settings.SHORTCUT_CLOSE_TAB].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_FORMULA_TAB)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return closeActiveTab(store);
    }

    if (
        manualShortcuts[settings.SHORTCUT_SPECTRO] !== undefined &&
        manualShortcuts[settings.SHORTCUT_SPECTRO].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_SPECTRO_TAB)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return {
            type: actionTypes.MENU_ADD_NEW_SPECTRO_TAB
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_MY_ORDERS] !== undefined &&
        manualShortcuts[settings.SHORTCUT_MY_ORDERS].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_MY_ORDERS_TAB)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return {
            type: actionTypes.MENU_ADD_NEW_MY_ORDERS_TAB
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_PRINT] !== undefined &&
        manualShortcuts[settings.SHORTCUT_PRINT].equals(event) &&
        store.login.loggedUser.canRead(resources.FUNCTION_PRINT) &&
        store.settings.printOnRequest
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return checkPrint(store);
    }

    if (
        manualShortcuts[settings.SHORTCUT_ORDER] !== undefined &&
        manualShortcuts[settings.SHORTCUT_ORDER].equals(event) &&
        store.login.loggedUser.canRead(resources.FUNCTION_ORDER)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return checkOrder(store);
    }

    if (
        manualShortcuts[settings.SHORTCUT_LOG_IN_AS] !== undefined &&
        manualShortcuts[settings.SHORTCUT_LOG_IN_AS].equals(event)
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_MODAL,
            payload: {
                tabId: componentTypes.MODAL_NO_TAB,
                type: componentTypes.AUTHENTICATION_MODAL,
                params: {changeUser: true}
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_HINT_TOOLTIPS] !== undefined &&
        manualShortcuts[settings.SHORTCUT_HINT_TOOLTIPS].equals(event)
    ) {
        return {
            type: actionTypes.SAVE_ACTIVE_HELP,
            payload: {
                activeHelp: !store.navigation.activeHelp
            }
        };
    }

    if (
        store.navigation.activeTabType === componentTypes.MAIN_TAB &&
        store.formula[store.navigation.activeTab] !== undefined &&
        (store.formula[store.navigation.activeTab].active ||
            store.navigation.activeTab === componentTypes.QUICK_TINT_TAB_ID) &&
        store.formula[store.navigation.activeTab].dispensing === false &&
        store.rcc.dispensingFormula === null &&
        !store.navigation.activeMenu
    ) {
        if (store.navigation.modalList.length > 0) {
            return {
                type: actionTypes.UNKNOWN_ACTION
            };
        }

        if (event.keyCode === keyCodes.RIGHT_ARROW) {
            return selectBiggerPackageSize(store);
        }

        if (event.keyCode === keyCodes.LEFT_ARROW) {
            return selectSmallerPackageSize(store);
        }

        if (event.keyCode === keyCodes.UP_ARROW || event.keyCode === keyCodes.DOWN_ARROW) {
            return selectDifferentPackageNumber(store, event.keyCode);
        }
    }

    if (
        manualShortcuts[settings.SHORTCUT_QUICK_TINT] !== undefined &&
        manualShortcuts[settings.SHORTCUT_QUICK_TINT].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_QUICK_TINT_MODAL)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return {
            type: actionTypes.NAVIGATION_OPEN_JUST_ONE_MODAL,
            payload: {
                tabId: componentTypes.MODAL_NO_TAB,
                type: componentTypes.QUICK_TINT_MODAL,
                style: componentTypes.MODAL_DEFAULT_STYLE
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_CANISTERS] !== undefined &&
        manualShortcuts[settings.SHORTCUT_CANISTERS].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_CANISTERS_TAB)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return {
            type: actionTypes.MENU_ADD_NEW_CANISTERS_TAB
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_TO_DISPENSE] !== undefined &&
        manualShortcuts[settings.SHORTCUT_TO_DISPENSE].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_TO_DISPENSE_TAB)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return {
            type: actionTypes.MENU_ADD_NEW_TO_DISPENSE_TAB
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_DISPENSING] !== undefined &&
        manualShortcuts[settings.SHORTCUT_DISPENSING].equals(event) &&
        store.login.loggedUser.canRead(resources.FUNCTION_DISPENSING)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return checkDispensing(store);
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const processRedlikeLightShortcut = (event, store) => {
    let manualShortcuts = store.settings.keyboardShortcuts;

    if (
        manualShortcuts[settings.SHORTCUT_CHANGELOG] !== undefined &&
        manualShortcuts[settings.SHORTCUT_CHANGELOG].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_CHANGELOG)
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_JUST_ONE_MODAL,
            payload: {
                tabId: componentTypes.MODAL_NO_TAB,
                type: componentTypes.CHANGELOG_MODAL,
                style: componentTypes.MODAL_DEFAULT_STYLE
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_SPECTRO] !== undefined &&
        manualShortcuts[settings.SHORTCUT_SPECTRO].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_SPECTRO_TAB)
    ) {
        return {
            type: actionTypes.MENU_ADD_NEW_SPECTRO_TAB
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_LOG_IN_AS] !== undefined &&
        manualShortcuts[settings.SHORTCUT_LOG_IN_AS].equals(event)
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_MODAL,
            payload: {
                tabId: componentTypes.MODAL_NO_TAB,
                type: componentTypes.AUTHENTICATION_MODAL,
                params: {changeUser: true}
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_ORDER] !== undefined &&
        manualShortcuts[settings.SHORTCUT_ORDER].equals(event) &&
        store.login.loggedUser.canRead(resources.FUNCTION_ORDER)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return checkOrderLight(store);
    }

    if (
        manualShortcuts[settings.SHORTCUT_PRINT] !== undefined &&
        manualShortcuts[settings.SHORTCUT_PRINT].equals(event) &&
        store.login.loggedUser.canRead(resources.FUNCTION_PRINT) &&
        store.settings.printOnRequest
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return checkPrintLight(store);
    }

    if (
        manualShortcuts[settings.SHORTCUT_QUICK_TINT] !== undefined &&
        manualShortcuts[settings.SHORTCUT_QUICK_TINT].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_QUICK_TINT_MODAL)
    ) {
        return {
            type: actionTypes.NAVIGATION_OPEN_JUST_ONE_MODAL,
            payload: {
                tabId: componentTypes.MODAL_NO_TAB,
                type: componentTypes.QUICK_TINT_MODAL,
                style: componentTypes.MODAL_DEFAULT_STYLE
            }
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_TO_DISPENSE] !== undefined &&
        manualShortcuts[settings.SHORTCUT_TO_DISPENSE].equals(event) &&
        store.login.loggedUser.canRead(resources.COMPONENT_TO_DISPENSE_TAB)
    ) {
        return {
            type: actionTypes.MENU_ADD_NEW_TO_DISPENSE_TAB
        };
    }

    if (
        manualShortcuts[settings.SHORTCUT_DISPENSING] !== undefined &&
        manualShortcuts[settings.SHORTCUT_DISPENSING].equals(event) &&
        store.login.loggedUser.canRead(resources.FUNCTION_DISPENSING)
    ) {
        if (store.navigation.modalList.length > 0) {
            return messageHelper.getWarningMessageAction("flashMessage.keyboardShortcutUsedInModal");
        }

        return checkDispensingLight(store);
    }

    return {
        type: actionTypes.UNKNOWN_ACTION
    };
};

const isFocused = () => {
    if (document.activeElement === null) {
        return false;
    }

    if (document.activeElement.tagName === "TEXTAREA") {
        return true;
    }

    if (document.activeElement.tagName !== "INPUT") {
        return false;
    }

    if (
        document.activeElement.getAttribute("type") === "text" ||
        document.activeElement.getAttribute("type") === "password" ||
        document.activeElement.getAttribute("type") === "email" ||
        document.activeElement.getAttribute("type") === "number"
    ) {
        return true;
    }

    return false;
};

const processArrowAction = (store) => {
    if (store.navigation.activeTabType !== componentTypes.COLOR_TAB) {
        return false;
    }

    if (
        store.searchPanel[store.navigation.activeTab] === undefined ||
        store.searchPanel[store.navigation.activeTab].activeSelect === componentTypes.SEARCH_PANEL_FORMULA
    ) {
        return false;
    }

    if (window.jQuery("#tab-" + store.navigation.activeTab + "-formula-select-box").length) {
        window.jQuery("#tab-" + store.navigation.activeTab + "-formula-select-box").focus();
    }

    return true;
};

export const processKeyboardEvent = (event, store) => {
    if (store.navigation.screenSaver && event.keyCode !== keyCodes.F8) {
        return [
            {
                type: actionTypes.NAVIGATION_CLOSE_SCREENSAVER
            }
        ];
    }

    if (store.navigation.blocked) {
        return [];
    }

    if (event.keyCode === keyCodes.ESCAPE) {
        if (store.navigation.modalList.length > 0) {
            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_ALL_MODALS
                }
            ];
        }

        if (isFocused()) {
            document.activeElement.blur();

            return [];
        }

        if (
            store.navigation.activeDialog === componentTypes.RCC_MACHINE_DIALOG &&
            store.rcc.machine.dialog !== null &&
            store.rcc.machine.dialog.buttons.includes(rcc.RCC_BTN_ABORT)
        ) {
            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
                        params: {
                            dialogID: store.rcc.machine.dialog.id,
                            msgBtn: rcc.RCC_BTN_ABORT
                        }
                    },
                    method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
                    tabId: 0,
                    safe: false
                }
            ];
        }

        if (store.navigation.activeMenu) {
            return [
                {
                    type: actionTypes.MENU_HIDE
                }
            ];
        }
    }

    let actions = [];

    if (event.keyCode === keyCodes.ENTER) {
        if (store.barcode.barcode.length > 0 || store.barcode.manualScan) {
            if (store.barcode.manualScan) {
                actions.push({
                    type: actionTypes.SHOW_MANUAL_SCAN,
                    payload: {
                        manualScan: false
                    }
                });
            }

            if (store.barcode.barcode.length > 0) {
                let barcodeEnterAction = onScannerEnterPress(store);

                if (barcodeEnterAction !== null) {
                    actions.push(barcodeEnterAction);

                    if (barcodeEnterAction.method !== handlers.GET_ITEM_BY_BARCODE_TEST) {
                        actions.push({type: actionTypes.BARCODE_RESET});
                    }
                }
            }
        }

        if (isFocused()) {
            if (document.activeElement?.tagName !== "TEXTAREA") {
                document.activeElement.blur();
            }

            return actions;
        }

        if (
            actions.length === 0 &&
            store.navigation.modalList.length === 0 &&
            store.navigation.activeDialog === componentTypes.RCC_MACHINE_DIALOG &&
            store.rcc.machine.dialog !== null &&
            store.rcc.machine.dialog.message !== rcc.RCC_MESSAGE_VALIDATE_BASE_CAN &&
            store.rcc.machine.dialog.buttons.length > 0
        ) {
            let button = store.rcc.machine.dialog.buttons.find(
                (btn) => btn === rcc.RCC_BTN_OK || btn === rcc.RCC_BTN_CONTINUE
            );

            if (button !== undefined && !isFocused()) {
                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
                            params: {
                                dialogID: store.rcc.machine.dialog.id,
                                msgBtn: button
                            }
                        },
                        method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
                        tabId: 0,
                        safe: false
                    }
                ];
            }
        }

        if (
            actions.length === 0 &&
            store.navigation.modalList.length === 0 &&
            store.login.loggedUser.canRead(resources.FUNCTION_DISPENSING)
        ) {
            if (store.module.redlikeLightSoftware) {
                return [checkDispensingLight(store)];
            }

            return [checkDispensing(store)];
        }
    }

    if (!event.ctrlKey && !event.shiftKey) {
        if (event.keyCode === keyCodes.F8) {
            actions.push(focusOnBarcodeScannerInput());

            if (
                store.module.gammaSoftware &&
                (store.module.name === modules.MODULE_FRONTDESK || store.intergammaMachine.overrideMode) &&
                (store.navigation.activeTabType === componentTypes.MAIN_TAB ||
                    store.navigation.activeTabType === componentTypes.ORDERS_HISTORY_TAB)
            ) {
                actions.push(messageHelper.getInfoMessageAction("flashMessage.scanning"));
            }

            if (store.navigation.screenSaver) {
                actions.push({type: actionTypes.NAVIGATION_CLOSE_SCREENSAVER});
            }
        }
    }

    if (event.ctrlKey) {
        if (event.keyCode === keyCodes.ADD && store.settings.zoom < config.MAX_ZOOM_LIMIT) {
            actions.push(zoomIn(store.settings.zoom));
        }

        if (event.keyCode === keyCodes.SUBTRACT && store.settings.zoom > config.MIN_ZOOM_LIMIT) {
            actions.push(zoomOut(store.settings.zoom));
        }

        if (event.keyCode === keyCodes.F && store.module.redlikeSoftware) {
            event.preventDefault();

            return [
                {
                    type: actionTypes.NAVIGATION_OPEN_JUST_ONE_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.FIND_TEXT_MODAL,
                        style: componentTypes.MODAL_BLANK_STYLE
                    }
                }
            ];
        }
    }

    if (isFocused()) {
        return actions;
    }

    if (
        event.keyCode === keyCodes.RIGHT_ARROW ||
        event.keyCode === keyCodes.DOWN_ARROW ||
        event.keyCode === keyCodes.LEFT_ARROW ||
        event.keyCode === keyCodes.UP_ARROW
    ) {
        processArrowAction(store);
    }

    if (store.settings.keyboardShortcuts === null || Object.keys(store.settings.keyboardShortcuts).length === 0) {
        return actions;
    }

    if (store.module.redlikeSoftware || store.module.colorisSoftware) {
        actions.push(processRedlikeShortcut(event, store));
    }

    if (store.module.redlikeLightSoftware) {
        actions.push(processRedlikeLightShortcut(event, store));
    }

    if (event.keyCode !== keyCodes.F12) {
        event.preventDefault();
    }

    return actions;
};
